<template>
  <div class="home">
      <div class="bg-black">
          <div class="container relative z-10 h-full mx-auto show-on-scroll">
            <nav class="flex flex-wrap items-center justify-between px-6 py-4 lg:pt-10">
                <div class="flex-1 lg:order-2">
                    <router-link to="/"><img src="/images/logo.png" alt="Aik Hock Tyre & Battery Services" class="h-12 lg:h-24 lg:mx-auto"></router-link>
                </div>
                <div class="flex-none mr-6 lg:order-1 lg:flex-1">
                    <div class="flex items-center text-lg text-white">
                        <a href="tel:91780773">
                            <img src="/images/call-us-icon.png" alt="Call Us" class="inline-block h-10 md:mr-2 lg:h-12"> <span class="hidden md:inline-block">9178 0773</span>
                        </a>
                    </div>
                </div>
                <div class="flex-none lg:order-3 lg:flex-1">
                    <div class="flex items-center text-lg text-white lg:justify-end">
                        <a href="https://wa.me/6591780773" target="_blank">
                            <img src="/images/whatsapp-icon.png" alt="Whats App" class="inline-block h-10 align-top md:mr-2 lg:h-12">
                            <div class="hidden leading-none md:inline-block md:mt-1">
                                <div class="mb-1 text-xs">WhatsApp</div>
                                <div>9178 0773</div>
                            </div>
                        </a>
                    </div>
                </div>
            </nav>
        </div>
      </div>
      <div class="px-4 py-20 text-center bg-siteSkyBlue">
        <p class="text-2xl md:text-3xl title-text">Message Sending Successful!</p>
        <p>Thank you for your kind interest in WSC Water Kids. We will get back to you as soon as possible.</p>
      </div>
      <Footer />
  </div>
</template>

<script>
  // @ is an alias to /src
    import Footer from '@/components/Footer.vue'

    export default {
        name: 'Home',
        components: {
            Footer
        }
    }
  </script
</script>
